import { staticCodes } from "../cro/common";
import { getPTC } from "../cro/getPTC";
import { PlanType } from "../types/planType";

const savingPercentage = (marketPrice: number, planPrice: number) =>
  Math.round(((marketPrice - planPrice) / marketPrice) * 100);

export const injectIsFeaturedPlans = async (
  plans: PlanType[],
  utilityId: string
) => {
  if (utilityId && plans?.length > 0) {
    const staticZipCode = staticCodes.find(
      (code) => utilityId && Object.keys(code).includes(utilityId)
    );

    const res = await getPTC(staticZipCode, utilityId);
    const marketPrice = parseFloat(res?.total_average_price);
    const marketName = res?.name;

    // Calculate savings for gas plans and find the one with the highest savings > 5%
    let highestGasPlanIndex = -1;
    let highestGasSavings = 0;

    let highestElectricPlanIndex = -1;
    let highestElectricSavings = 0;

    plans.forEach((plan, index) => {
      if (plan.commodity_name === "Gas") {
        const savings = savingPercentage(
          marketPrice,
          parseFloat(String(plan.rate || "0"))
        );
        if (savings > highestGasSavings && savings > 5) {
          highestGasSavings = savings;
          highestGasPlanIndex = index;
        }
      } else if (plan.commodity_name === "Electric") {
        const plan_rate = plan.plan_name.toLowerCase().includes("flexstart")
          ? plan.price1000
          : plan.price2000;
        const savings = savingPercentage(
          marketPrice,
          parseFloat(String(plan_rate || "0"))
        );
        if (savings > highestElectricSavings && savings > 5) {
          highestElectricSavings = savings;
          highestElectricPlanIndex = index;
        }
      }
    });

    return plans.map((plan, index) => {
      const isGas = plan?.commodity_name === "Gas";
      const isElectric = plan?.commodity_name === "Electric";

      if (isGas) {
        const savings = savingPercentage(
          marketPrice,
          parseFloat(String(plan.rate || "0"))
        );
        const isFeatured = index === highestGasPlanIndex;

        return {
          ...plan,
          isFeatured,
          ef_plan_details: {
            ...(plan?.ef_plan_details || {}),
            callout_color: isFeatured ? "#488262" : undefined,
            callout_text: isFeatured
              ? `${savings}% Savings vs ${marketName || "Market Average"}`
              : "",
            callout_text_spanish: isFeatured
              ? `${savings}% Ahorro vs ${marketName || "Promedio del Mercado"}`
              : "",
          },
        };
      }

      if (isElectric && Number(plan?.Ef_Order) === 2) {
        return {
          ...plan,
          isFeatured: true,
          ef_plan_details: {
            ...(plan?.ef_plan_details || {}),
            callout_color: "#488262",
            callout_text: "Most Popular",
          },
        };
      }

      if (isElectric && index === highestElectricPlanIndex) {
        const plan_rate = plan.plan_name.toLowerCase().includes("flexstart")
          ? plan.price1000
          : plan.price2000;

        const savings = savingPercentage(
          marketPrice,
          parseFloat(String(plan_rate || "0"))
        );
        return {
          ...plan,
          ef_plan_details: {
            ...(plan?.ef_plan_details || {}),
            electric_savings: `${savings}% Savings vs ${
              marketName || "Market Average"
            }`,
            electric_savings_spanish: `${savings}% Ahorro vs ${
              marketName || "Promedio del Mercado"
            }`,
          },
        };
      }

      return plan;
    });
  }

  return plans;
};
